<div class="dealer-selector">
    <h4>DEALER SELECTOR</h4>
    <div class="item" *ngFor="let store of dealers" [class.selected]="(store.id && store.id === dealer.id) || (store.dealer_reference && store.dealer_reference === dealer.reference)" (click)="onDealerClick(store)">
        <ion-icon name="checkmark-circle" *ngIf="(store.id && store.id === dealer.id) || (store.dealer_reference && store.dealer_reference === dealer.reference)"></ion-icon>
        <h5>{{ displayName(store) }}</h5>
        <p>{{ displayAddress(store) }}</p>
        <div class="circle" *ngIf="store.alerts !== undefined" [class.new]="store.alerts > 0">{{ store.alerts }}</div>
    </div>
</div>


